export default {
    flats: "byty",
    houses: "domy",
    lands: "pozemky",
    commercial: "komercni-nemovitosti",
    other: "ostatni",
};
